import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";
import { Link } from "react-scroll";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import "swiper/css/autoplay";
import './Hero.css'

const Hero = ({ bannerData, isMobile }) => {
  // Check if more than one slide exists
  const hasMultipleSlides = bannerData.length > 1;

  return (
    <div className="homeslider col-12 float-start">
      <div className="swiper-component col-lg-11 mx-auto">
        <Swiper
          modules={[Navigation, Pagination, Autoplay, EffectFade]}
          navigation={hasMultipleSlides} // ✅ Only enable when multiple slides
          pagination={hasMultipleSlides ? { clickable: true } : false} // ✅ Same for pagination
          effect="fade"
          autoplay={
            hasMultipleSlides
              ? {
                delay: 5000,
                disableOnInteraction: false,
              }
              : false
          } // ✅ No autoplay if only one slide
          loop={hasMultipleSlides}
          className="mySwiper"
        >
          {bannerData.map((banner, i) => (
            <SwiperSlide key={i}>
              <picture>
                {/* WebP version for browsers that support it */}
                {isMobile ? (
                  <source srcSet={banner.mobile_img} type="image/webp" />
                ) : (
                  <source srcSet={banner.img} type="image/webp" />
                )}

                {/* Fallback <img> always loads the proper image */}
                <img
                  src={isMobile ? banner.mobile_img : banner.img}
                  alt={banner.alt || `Banner ${i + 1}`}
                  className="w-100"
                  width={isMobile ? "612" : "1920"}
                  height={isMobile ? "980" : "870"}
                  fetchPriority={i === 0 ? "high" : "low"}
                  loading={i === 0 ? "eager" : "lazy"}
                  decoding="async"
                />
              </picture>

              {banner.banner_text && (
                <div className="slidercont" id="product">
                  <h3 dangerouslySetInnerHTML={{ __html: banner.banner_text }} />
                </div>
              )}
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Down Arrow */}
        <Link to="product" smooth duration={500}>
          <div className="downarrow">
            <span className="animated bounce white_line"></span>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default Hero;
